import { getAmountFromMoneyString } from 'lib/util/util';
import { ReservationLineItem } from 'models/reservation';

interface Item {
  id: string;
  name: string;
  brand?: string;
  category?: string;
  variant?: string;
  price?: number;
  quantity?: number;
  coupon?: string;
  list_position?: number;
}

interface PurchaseData {
  transaction_id: string;
  affiliation?: string;
  value?: number;
  tax?: number;
  currency?: string;
  shipping?: number;
  items?: Item[];
  checkout_step?: number;
  checkout_option?: string;
}

export const analyticsViewItem = (items: Item[]) => {
  window.gtag('event', 'view_item', {
    items,
  });
  window.gtmEvent?.({ ecommerce: null });
  window.gtmEvent?.({
    event: 'gtm_view_item',
    ecommerce: {
      items,
    },
  });
};

export const analyticsAddToCart = (items: Item[]) => {
  window.gtag('event', 'add_to_cart', {
    items,
  });
  window.gtmEvent?.({ ecommerce: null });
  window.gtmEvent?.({
    event: 'gtm_add_to_cart',
    ecommerce: {
      items,
    },
  });
};

export const analyticsBeginCheckout = (items: Item[]) => {
  window.gtag('event', 'begin_checkout', {
    items,
  });
  window.gtmEvent?.({ ecommerce: null });
  window.gtmEvent?.({
    event: 'gtm_begin_checkout',
    ecommerce: {
      items,
    },
  });
};

export const analyticsPurchase = (req: PurchaseData) => {
  window.gtag('event', 'purchase', req);
  window.gtmEvent?.({ ecommerce: null });
  window.gtmEvent?.({
    event: 'gtm_purchase',
    ecommerce: {
      transaction_id: req.transaction_id,
      affiliation: req.affiliation,
      currency: req.currency,
      value: req.value,

      items: req?.items,
    },
  });
};

// const convertGtagItemsToGTMItems = (items: Item[]): GTMItem[] => {
//   return items.map((item) => ({
//     item_name: item.name,
//     item_id: item.id,
//     item_brand: item.brand,
//     item_variant: item.variant || '',
//     price: item.price,
//     quantity: item.quantity,
//   }));
// };

export const convertLineItemsToGtagItems = (
  productId: string,
  productName: string,
  supplierName: string,
  lineItems: ReservationLineItem[]
): Item[] => {
  return lineItems.map((lineItem) => {
    const price = getAmountFromMoneyString(lineItem.amount_gross);

    return {
      id: productId,
      name: productName,
      brand: supplierName,
      variant: lineItem.title || '',
      price,
      quantity: lineItem.count || 0,
    };
  });
};
